import { initEditor, config } from './froala-editor';
import { compress } from './token';

/**
 * The Froala Editors (service may store multiple instances)
 * @type {Object}
 * @private
 */
const _$editors = {};

export default class richTextEditorService {
  constructor() {
    this.config = config;
    console.log('app.components.pm.richTextEditorService created');
  }

  getContent(id) {
    const html = _$editors[id].froalaEditor('html.get', true);
    return compress(html);
  }

  /**
   *
   * @param {string} id - An id by which to store and retrieve this editor
   * @param {jQuery} $el - The jQuery element to turn into an editor
   * @param {Object} options - Overrides to the editor's options
   * @return {jQuery} $editor - Returns the jQuery editor element
   */
  create(id, $el, options, tokensEnabled) {
    _$editors[id] = initEditor($el, options, tokensEnabled);
    return _$editors[id];
  }

  destroy(id) {
    _$editors[id] = null;
  }
}
